import { createSliceSelectors } from '../utils'

const MapSelectors = createSliceSelectors('map', [
    'mapData', //currently open trigger id
    'mapDisplayMode',
    'mapZoomBounds',
])

export default MapSelectors
